import * as React from 'react';
import Spinner from '../../../common/components/spinner/spinner';
import Translate from '../../../common/functions/translate';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import ConditionUnitTypeList from './conditionUnitTypeList';
import { ConditionUnitRangeModel } from '../../../models/conditionUnitRangeModel';
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import { Lang, UserConditionType } from '../../../common/enums';
import { array } from 'prop-types';
import ConditionUnitRangeService from '../../../services/conditionUnitTypeService';
import { ConditionUnitRangeSettingModel } from '../../../models/conditionUnitRangeSettingModel';
import { Dropdown } from 'primereact/dropdown';
import { enumToDropdownArray } from '../../../common/functions/helperFunctions';
import { DropdownModel } from "../../../models/dropdownModel";
import { Toolbar } from 'primereact/toolbar';
import { Button } from "primereact/button";
import ConditionUnitTypeAddEditDialog from './conditionUnitTypeAddEditDialog';

interface IProps {
}

interface IState {
    error: any,
    isLoading: boolean,
    isVisibleDialogWrap: boolean,
    isVisibleDialog: boolean,
    numberOfRows: number,
    totalRecordsCount: number,
    first: number,
    isVisibleConfirmDialog: boolean,
    validationMessage: string,
    unitRanges: Array<ConditionUnitRangeModel>,
    filterConditionTypeId: number,
    userConditionDropdown: Array<DropdownModel>,
    filterText: string,
    currentSettings: ConditionUnitRangeSettingModel,
    selectedUnitRangeId: number;
    currentUnitRange: ConditionUnitRangeModel
}

const initFrom = 0;
const numberOfRows = 10;

class ConditionUnitTypeContainer extends React.Component<IProps, IState> {
    messages: any;
    conditionUnitRangeService = new ConditionUnitRangeService();
    constructor(props: IProps) {
        super(props);

        this.state = {
            error: null,
            isLoading: false,
            isVisibleDialogWrap: false,
            isVisibleDialog: false,
            numberOfRows: numberOfRows,
            first: initFrom,
            totalRecordsCount: 0,
            isVisibleConfirmDialog: false,
            validationMessage: '',
            unitRanges: new Array<ConditionUnitRangeModel>(0),
            filterConditionTypeId: 0,
            userConditionDropdown: new Array<DropdownModel>(0),
            filterText: '',
            currentSettings: new ConditionUnitRangeSettingModel(),
            selectedUnitRangeId: 0,
            currentUnitRange: new ConditionUnitRangeModel()
        }
    }

    componentDidMount() {
        const firstItem: Array<DropdownModel> = [{ label: 'Select', value: -1 }];
        this.setState({
            userConditionDropdown: firstItem.concat(enumToDropdownArray(UserConditionType))
        }, () => this.getAllUnitTypes(this.state.first, this.state.numberOfRows));
    }

    handleOnPageClick = (e) => {
        const startIndex = e.first;
        this.getAllUnitTypes(startIndex, this.state.numberOfRows);
    }

    getAllUnitTypes(from: number, numberOfRows: number) {
        this.setState({
            isLoading: true
        });
        let settings: ConditionUnitRangeSettingModel = new ConditionUnitRangeSettingModel();
        if (this.state.currentSettings && this.state.currentSettings.systemTypeConditionId && this.state.currentSettings.systemTypeConditionId > 0) {
            settings.systemTypeConditionId = this.state.currentSettings.systemTypeConditionId;
        }
        this.conditionUnitRangeService.getAll(from, numberOfRows, settings).then(
            (data) => {
                this.setState({
                    isLoading: false,
                    first: from,
                    unitRanges: data.conditionUnitTypes,
                    totalRecordsCount: data.totalRecords
                });
            })
            .catch(error => {
                this.setState({
                    isLoading: false,
                    error
                });
            });
    }

    setCurrentUnitRange = (unitRange: ConditionUnitRangeModel) => {
        this.setState({ currentUnitRange: { ...unitRange } });
    }

    handleAddAndEditClick = id => {
        if (!id) { // Add			
            let disposal = new ConditionUnitRangeModel();
            this.setCurrentUnitRange(disposal);
            this.showEditDialog(true);
        } else { // Edit
            this.setState({
                isLoading: true
            });
            this.conditionUnitRangeService.getById(id)
                .then(
                    (data: ConditionUnitRangeModel) => {
                        this.setCurrentUnitRange(data);
                        this.showEditDialog(true);
                        this.setState({
                            isLoading: false
                        });
                    },
                    error => {
                        this.setState({
                            error,
                            isLoading: false
                        });
                    }
                );
        }
    };

    handleDeleteClick = (id) => {
        this.setState({
            isVisibleConfirmDialog: true,
            selectedUnitRangeId: id
        });
    };

    deleteUnitRange(id) {
        this.setState({
            isVisibleConfirmDialog: false,
            isLoading: true
        });

        this.conditionUnitRangeService.deleteConditionUnitType(id)
            .then(
                data => {
                    this.setState({ first: 0 }, () => this.getAllUnitTypes(0, this.state.numberOfRows));
                },
                error => {
                    this.setState({
                        error,
                        isLoading: false
                    });
                });
    }

    showEditDialog = (show: boolean) => {
        this.setState({
            isVisibleDialogWrap: show,
            validationMessage: ''
        });
        setTimeout(() => this.setState({
            isVisibleDialog: show
        }));
    };

    handleFilterChange = (value) => {
        this.setState({ filterConditionTypeId: value, first: 0 });
    }

    generateFilterText = (settings: ConditionUnitRangeSettingModel) => {
        let result = '';

        if (settings.systemTypeConditionId) {
            result += "Condition system type <strong>'" + HelperFunctions.getEnumLabel(settings.systemTypeConditionId, UserConditionType) + "'</strong>, "
        }

        return result.substr(0, result.length - 2);
    }

    handleSearchButtonClick = () => {
        let currentFilter = { ...this.state.currentSettings };
        currentFilter.systemTypeConditionId = this.state.filterConditionTypeId;
        let filterText = this.generateFilterText(currentFilter);
        this.setState({ currentSettings: { ...currentFilter }, filterText: filterText }, () => this.getAllUnitTypes(0, this.state.numberOfRows));
    }

    handleClearButtonClick = () => {
        this.setState({ currentSettings: new ConditionUnitRangeSettingModel(), filterConditionTypeId: 0, filterText: '' }, () => this.getAllUnitTypes(0, this.state.numberOfRows))
    }

    handleCancelButton = () => {
        this.showEditDialog(false);
    };

    handleSaveButton = (currentUnitRange: ConditionUnitRangeModel, close: boolean) => {
        this.setState({
            isLoading: true
        });

        if (!currentUnitRange.conditionUnitRangeId) { // Add
            this.conditionUnitRangeService.addConditionUnitType(currentUnitRange)
                .then(
                    (data) => {
                        if (close) {
                            this.showEditDialog(false);

                        }
                        this.setCurrentUnitRange(new ConditionUnitRangeModel());
                        this.getAllUnitTypes(this.state.first, this.state.numberOfRows);
                        this.setState({
                            isLoading: false
                        });
                    },
                    error => {
                        this.showEditDialog(false);
                        this.setCurrentUnitRange(new ConditionUnitRangeModel());
                        this.setState({
                            error
                        });
                        this.setState({
                            isLoading: false
                        });
                    }
                );
        } else { // Edit
            this.conditionUnitRangeService.editConditionUnitType(currentUnitRange.conditionUnitRangeId, currentUnitRange)
                .then(
                    (data) => {
                        if (close) {
                            this.showEditDialog(false);
                        }
                        this.setCurrentUnitRange(new ConditionUnitRangeModel());
                        this.getAllUnitTypes(this.state.first, this.state.numberOfRows);
                        this.setState({
                            isLoading: false
                        });
                    },
                    error => {
                        this.showEditDialog(false);
                        this.setCurrentUnitRange(new ConditionUnitRangeModel());
                        this.setState({
                            error
                        });
                        this.setState({
                            isLoading: false
                        });
                    });
        }
    };

    public render() {

        const { isLoading, error, totalRecordsCount, first, numberOfRows, unitRanges,
            filterConditionTypeId, userConditionDropdown, selectedUnitRangeId, currentUnitRange } = this.state;

        return (
            <div>

                <h3>Condition unit range</h3>

                {isLoading ? <Spinner /> : null}

                {error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}

                {this.state.isVisibleDialogWrap ? (
                    <ConditionUnitTypeAddEditDialog
                        currentUnitRange={currentUnitRange}
                        isVisible={this.state.isVisibleDialog}
                        saveClick={this.handleSaveButton}
                        cancelClick={this.handleCancelButton}
                    />
                ) : null}

                <div className="mb-2">
                    <button
                        onClick={() => this.handleAddAndEditClick(null)}
                        className="btn btn-success"
                        style={{ marginRight: "5px" }}>
                        Add New
         			 </button>
                </div>
                <Toolbar style={{ marginBottom: '10px' }}>
                    <div style={{ width: 200, paddingTop: 10, paddingBottom: 10 }}>
                        <label>User condition type:</label>
                        <Dropdown
                            value={filterConditionTypeId ? filterConditionTypeId : -1}
                            options={userConditionDropdown}
                            onChange={(e) => this.handleFilterChange(e.value)}
                            style={{ width: '100%' }}
                        />
                    </div>

                    <div>
                        <div style={{ float: "left", paddingTop: "5px", marginBottom: "5px" }}>
                            Result: <strong>{this.state.totalRecordsCount}</strong>
                            {this.state.filterText ? ', ' : ''}
                            <span dangerouslySetInnerHTML={{ __html: this.state.filterText }}></span>
                        </div>
                        <div style={{ float: "right" }}>
                            <div>
                                <Button
                                    className="p-button-raised"
                                    icon="pi pi-filter"
                                    style={{ marginRight: "10px" }}
                                    label="Filter"
                                    onClick={() => this.handleSearchButtonClick()}
                                />
                                <Button
                                    className="p-button-secondary p-button-raised"
                                    label="Clear"
                                    icon="pi pi-times"
                                    onClick={() => this.handleClearButtonClick()}
                                />
                            </div>
                        </div>
                    </div>
                </Toolbar>
                <ConditionUnitTypeList
                    unitRanges={unitRanges}
                    rows={numberOfRows}
                    totalRecords={totalRecordsCount}
                    onPageClick={this.handleOnPageClick}
                    first={first}
                    loading={Spinner}
                    editClick={this.handleAddAndEditClick}
                    deleteClick={this.handleDeleteClick}
                />

                <ConfirmDialog
                    headerTitle="Confirm Dialog"
                    isVisible={this.state.isVisibleConfirmDialog}
                    yesClick={() => { this.deleteUnitRange(this.state.selectedUnitRangeId) }}
                    noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
                    Are you sure that you want to delete the selected condition unit range?
        </ConfirmDialog>
            </div>
        )
    }
}

export default ConditionUnitTypeContainer;